<span class="badge m-0 ml-1" v-if="numUnread &gt; 0" v-translate="translateTitleOptions">{{ numUnread }}</span>